import React, { useState, useEffect } from 'react'
import FormInput from "../../../common/form/form-input";
import TogglePanel from '../../../common/toggle-panel';

function Integrations(props) {
  const [location, setLocation] = useState(props.location);
  useEffect(function () {
    setLocation(props.location)
  }, [props.location])

  return (
    <div className="mx-auto max-w-7xl px-6 pb-6">
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" id="integrations">
        <TogglePanel name='Integrations' initOpen={true}>
          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <dl className="border-t border-gray-200 sm:divide-y sm:divide-gray-200">
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>COMDATA ID</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.comdata_id}
                    field="comdata_id"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>EFS ID</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.efs_id}
                    field="efs_id"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Opis ID</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.opis_id}
                    field="opis_id"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>MS Fuel Card ID</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.msfuelcard_id}
                    field="msfuelcard_id"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Quikq ID</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.quikq_id}
                    field="quikq_id"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Relay ID</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.relay_id}
                    field="relay_id"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Google Place ID</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.google_place_id}
                    field="google_place_id"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Google Place Url</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.google_place_url}
                    field="google_place_url"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>
            </dl>
          </div>
        </TogglePanel>
      </div>
    </div>
  )
}

export default Integrations;